module.exports = __webpack_public_path__ + "img/i4.b781587a.png";